import { texts } from '../../chunk-YZFUAOPE.mjs';
import '../../chunk-D6FLC3TD.mjs';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ErrorOutline } from '@mui/icons-material';
import { jsx, jsxs } from 'react/jsx-runtime';

var ErrorFallback = (props) => {
  const { errorMessage = texts.message, canRetry = true } = props;
  return /* @__PURE__ */ jsx(Box, { display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", bgcolor: "background.default", children: /* @__PURE__ */ jsx(Container, { maxWidth: "sm", children: /* @__PURE__ */ jsx(Card, { elevation: 12, children: /* @__PURE__ */ jsxs(CardContent, { sx: { textAlign: "center" }, children: [
    /* @__PURE__ */ jsx(
      ErrorOutline,
      {
        color: "error",
        sx: {
          fontSize: 80,
          mb: 2
        }
      }
    ),
    /* @__PURE__ */ jsxs(Box, { textAlign: "center", py: 2, children: [
      /* @__PURE__ */ jsx(Typography, { variant: "h5", component: "h2", gutterBottom: true, children: texts.title }),
      /* @__PURE__ */ jsx(Typography, { color: "text.secondary", variant: "body2", gutterBottom: true, children: errorMessage }),
      canRetry && /* @__PURE__ */ jsx(Box, { mt: 3, children: /* @__PURE__ */ jsx(Button, { variant: "contained", fullWidth: true, onClick: () => window.location.reload(), children: texts.tryAgain }) })
    ] })
  ] }) }) }) });
};

export { ErrorFallback };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map